import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Card, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { GetUpcomingSeriesListAction, ResetGetUpcomingSeriesListAction, ResetSeriesChangeStatusAction, SeriesFootballChangeStatusAction } from '../../redux/actions/SeriesAction';
import Loader from 'src/components/Loader';
import moment from 'moment';

export default function UpcomingSeriesList() {
    const dispatch = useDispatch();
    const ContestListData = useSelector(state => state.matches.upcoming_series_list.data)
    const loadingSelector = useSelector(state => state.series.loading)
    const statusSelector = useSelector(state => state.series.series_action)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [state, setState] = useState({
        ContestListData: [],
        totalCountContestList: 0,
    })

    useEffect(() => {
        if (ContestListData !== undefined) {
            setState({ ...state, ContestListData: ContestListData.data.series_list, totalCountContestList: ContestListData.data.total_count })
        }
    }, [ContestListData])

    useEffect(() => {
        dispatch(GetUpcomingSeriesListAction(page, rowsPerPage, "fb"))

        return () => dispatch(ResetGetUpcomingSeriesListAction())
    }, [dispatch, page, rowsPerPage])

    useEffect(() => {
        if (Object.keys(statusSelector).length > 0) {
            dispatch(GetUpcomingSeriesListAction(page, rowsPerPage, "fb"))
            dispatch(ResetSeriesChangeStatusAction())
        }
    }, [statusSelector, page, rowsPerPage])

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const activateMatch = (event, is_active, match_id) => {
        event.preventDefault()
        let sendData = {
            cid: match_id,
            is_active: is_active
        }
        dispatch(SeriesFootballChangeStatusAction(sendData))
    }

    const InactivateMatch = (event, is_active, match_id) => {
        event.preventDefault()
        let sendData = {
            cid: match_id,
            is_active: is_active
        }
        dispatch(SeriesFootballChangeStatusAction(sendData))
    }
    return (
        <Page title="Upcoming Series Football List">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Upcoming Series List"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Upcoming Series Football List' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'c_id', label: 'League ID', alignRight: false },
                                        { id: 'c_season_id', label: 'Season ID', alignRight: false },
                                        { id: 'series_Name', label: 'Series Name', alignRight: false },
                                        { id: 'category', label: 'category', alignRight: false },
                                        { id: "c_date", label: "Date", alignRight: false },
                                        { id: 'c_action', label: 'Actions', alignRight: false }
                                    ]}
                                    rowCount={state.totalCountContestList}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {state.ContestListData.map((data, index) => {
                                        return (
                                            <>
                                                {data.is_active != 2 ?
                                                    <TableRow
                                                        key={index}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {page * rowsPerPage + (index + 1)}.
                                                        </TableCell>
                                                        <TableCell component="th" scope="row"> {data.league_id}</TableCell>
                                                        <TableCell component="th" scope="row"> {data.season_id}</TableCell>
                                                        <TableCell component="th" scope="row"> {data.name} </TableCell>
                                                        <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}>
                                                            {data.type}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {
                                                                data.date_start ?
                                                                    `${moment(data.date_start).format("DD MMM")}  to  ${moment(data.date_end).format("DD MMM YYYY")}`
                                                                    :
                                                                    "-"
                                                            }

                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {data.is_active === 1 ?
                                                                <Button size="small" color="success" onClick={(event) => activateMatch(event, 0, data.season_id)}
                                                                > Active </Button>
                                                                :
                                                                <Button size="small" color="error" onClick={(event) => InactivateMatch(event, 1, data.season_id)}
                                                                >  Inactive </Button>
                                                            }
                                                            {/* <Button size="small" color="error" onClick={(event) => activateMatch(event, 2, data.cid)}>Delete</Button> */}
                                                        </TableCell>
                                                    </TableRow> : ""}
                                            </>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountContestList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
